export const clientConfig = (config) => {
    const headers = {
        'Ocp-Apim-Subscription-Key': config.subscriptionKey,
    };
    return { headers, baseUrl: config.baseUrl };
};
